import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje} from '../components/mensajes';

import useTable from "../components/useTable"
import Controls from "../components/controls/Controls";

import { Dimmer} from '../components/spinner';

import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import axios from 'axios';


const CatalogoMesCerrado = props => {


    const headCells = props.tipo === 2 ? [ 
        { id: 'mes', label: 'MES', width: '100px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'anio', label: 'AÑO', width: '200px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'cuentabancaria', label: 'Nª DE CUENTA', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'idcuentabancaria', label: 'ID', width: '50px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        ]:
        [{ id: 'mes', label: 'MES', width: '100px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'anio', label: 'AÑO', width: '200px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
    ]
    

    let token = localStorage.getItem('jwtToken');
    let op = require('../../src/modulos/datos');

    const btnCancela = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [activate, setActivate] = useState(false);
    const [values, setValues] = useState({});
    const [itemSelect, setItemSelect] = useState(-1);
    const [activo, setActivo] = useState(true);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;
        props.tipo === 2 ? 
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.mes.toLowerCase().includes(target.value.toLowerCase())
                            || x.anio.includes(target.value)
                            || x.cuentabancaria.toLowerCase().includes(target.value.toLowerCase())
                            || x.idcuentabancaria.includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })
        :
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.mes.toLowerCase().includes(target.value.toLowerCase())
                            || x.anio.includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }



    const seleccionarMesCerados = () => {
        
        let endpoint = '';
        let campos = '';
        let nomtab = '';
        let condi = '';
        let orden = '';
        if (props.tipo === 1){
            campos = "UPPER(to_char(to_timestamp (mes::text, 'MM'), 'TMMonth')) AS mes, anio::text, mes AS mes1 ";
            nomtab = 'mescerrado';
            condi = 'modulo=' + "'" + props.modulo  + "'";
            orden = 'anio, mes1';
            endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
        } else if (props.tipo === 3){
            campos = "UPPER(to_char(to_timestamp (mes::text, 'MM'), 'TMMonth')) AS mes, anio::text, mes AS mes1 ";
            nomtab = 'mescerrado';
            condi = 'modulo=' + "'" + props.modulo  + "'" + ' AND idcuentabancaria = 0';
            orden = 'anio, mes1';
            endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
        } else {
            campos = "UPPER(to_char(to_timestamp (mes::text, 'MM'), 'TMMonth')) AS mes, anio::text, " +
                    "cuentabancaria, m.idcuentabancaria, mes AS mes1 ";
            let id = "'" + props.modulo + "'";
            nomtab = 'mescerrado';
            let nomid = 'modulo';
            let nomtab2 = 'cuentabancaria';
            let nomid3 = 'idcuentabancaria';
            endpoint = `${op.conexion}/api/consulta/modeli10rows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&nomtab2=${nomtab2}&nomid3=${nomid3}`;
        }

        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                setActivate(false);

                if (response.data.length > 0) {

                    /*var gest = []
                    for (let i = 0; i < response.data.length; i++) {
                        gest.push({
                            idgestor: response.data[i].idgestor,
                            responsable: response.data[i].responsable,
                            codigogestor: response.data[i].codigogestor,
                            nombres: response.data[i].nombres,
                        })
                    }*/
                    setRecords(response.data)
                    
                }

            }

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }


    const blanquear = () => {

        setMostrar(false);
        setTitulo('');
        setMsg('');
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
    }


    const handleCloseMensa = () => {
        setMostrar(false);
        seleccionarMesCerados();
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelaCat();
    }

    const seleccionarLista = (index) => (event) => {
        blanquear();
        props.onHideAceptaCat(values[0])

    };

    const seleccionarFila = (index) => (event) => {

        setItemSelect(index);
        setActivo(false);
        var mes = recordsAfterPagingAndSorting()[index].mes;
        var anio = recordsAfterPagingAndSorting()[index].anio;
        var mes1 = recordsAfterPagingAndSorting()[index].mes1;
        var idcuenta = recordsAfterPagingAndSorting()[index].idcuentabancaria;


        var datos = [];

        datos.push({
            mes,
            anio,
            mes1,
            idcuenta
        })
        setValues(datos);
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                seleccionarMesCerados()
            }}
        >
            <Modal.Header style={{ backgroundColor: "#019cd5" }}>
                <Modal.Title style={{ color: "#fff" }}>Seleccionar Mes Cerrado.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control rounded-pill search-input" />
</div>
</div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            
                            { props.tipo === 2 ?
                                records && recordsAfterPagingAndSorting().map((item, index) => (

                                    <tr key={item.mes || item.anio} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "100px" }}>{item.mes}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "200px" }}>{item.anio}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "80px" }}>{item.cuentabancaria}</td>
                                        <td style={{ fontSize: "10px", textAlign: "center", width: "50px" }}>{item.idcuentabancaria}</td>
                                    </tr>

                                ))
                                :
                                records && recordsAfterPagingAndSorting().map((item, index) => (

                                    <tr key={item.mes || item.anio} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "100px" }}>{item.mes}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "200px" }}>{item.anio}</td>
                                    </tr>

                                ))
                            }
                            
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={seleccionarLista()}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill col-md-2"><i className="fa"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoMesCerrado;